import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { AssetSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const assetsMenuItemTitle = 'Settings.Assets';

export const assetsMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Assets.AssetType',
    routerLink: AssetSettingsRouteName.AssetType,
    permissions: [RolesAndPermissions.AssetTypeSettingsRead],
  },
  {
    label: 'Settings.Assets.Location',
    routerLink: AssetSettingsRouteName.AssetLocation,
    permissions: [RolesAndPermissions.AssetLocationSettingsRead],
  },
];

export interface AssetTypeDataset extends AssetTypeResponse {
  tree: string[];
  treeObjectIds: number[];
}

export interface AssetTypeResponse {
  AssetTypeID: number;
  ParentAssetTypeID: number;
  AssetTypeDescription: string;
  ParentAssetTypeDescription: string;
}

export interface AssetTypeDto {
  AssetTypeDescription: string;
  IsSelectableForAsset: boolean;
  ParentAssetTypeID: number;
  IsMissingEquipmentNotificationEnabled: boolean;
  NotifyOfInactiveAssetAfterDays: number;
}
